import { clear as clearIndexedDB } from "idb-keyval";
import { useLocalStorage } from "PosterEditor/hooks/use-locale-storage";
import { useCheckout } from "BEDROCK/pages/checkout/checkout-provider";
import { useAuthContext } from "BEDROCK/auth/auth-provider";

export const useSignOutHandler = () => {
  const { removeAll: clearLocalStorage } = useLocalStorage();
  const { clearCheckout } = useCheckout();
  const { signOut: authSignOut } = useAuthContext();

  const signOut = async () => {
    try {
      clearCheckout();
      clearLocalStorage();
      await clearIndexedDB();
      await authSignOut();
    } catch (error) {
      console.error("Error clearing local store:", error);
    }
  };

  return { signOut };
};
